import type { Plugin } from '@nuxt/types';
import { SIGN_UP_POPUP, SIGN_UP_MODAL } from '@/constants/dynamicModals';

const OPEN_SIGN_UP_POPUP_DELAY = 30 * 1000;

/**
 * We need to hide cookie banner because it overlaps with sign up popup
 */
const hideCookieBanner = () => {
  document.querySelector('#onetrust-consent-sdk')?.setAttribute('style', 'display: none');
};

const showCookieBanner = () => {
  document.querySelector('#onetrust-consent-sdk')?.removeAttribute('style');
};

/**
 * That plugin open a SignUpPopup (at screen bottom) for unlogged in users after 30 seconds
 * browsing the war-room
 */
const SignUpPopupWithDelay: Plugin = ctx => {
  let timeout: ReturnType<typeof setTimeout>;
  let delay = OPEN_SIGN_UP_POPUP_DELAY;

  const openThePopup = function () {
    const isWarRoom = ctx.route.path.startsWith('/war-room');
    const hasOpenedModal = Boolean(ctx.app.$modal.current);
    if (ctx.$auth.loggedIn || !isWarRoom || hasOpenedModal) return;

    // Show different modal types for mobile and desktop PGE-113
    const modalToOpen = ctx.app.$device.isMobile ? SIGN_UP_MODAL : SIGN_UP_POPUP;
    ctx.app.$analytics.logEvent('global__sign-up-popup__open');
    ctx.app.$modal.options.transition = 'slideup';
    hideCookieBanner();
    ctx.app.$modal.show(modalToOpen, {
      onClose: () => {
        ctx.app.$analytics.logEvent('global__sign-up-popup__close');
        showCookieBanner();
      },
    });

    // Change transition back, otherwise all modals will have that transition
    // To fix that we should rewrite modal plugin to accept different transitions
    setTimeout(() => (ctx.app.$modal.options.transition = 'fade'), 300);
  };

  ctx.app.router?.afterEach(to => {
    const isWarRoom = to.path.startsWith('/war-room');
    if (ctx.$auth.loggedIn || !isWarRoom || timeout) return;

    // For debugging purposes - use ?sign_up_popup_delay=1
    if (to.query.sign_up_popup_delay) {
      delay = Number(to.query.sign_up_popup_delay) * 1000;
    }

    timeout = setTimeout(openThePopup, delay);
  });

  ctx.app.store?.watch(
    state => state.auth.loggedIn,
    loggedIn => {
      if (loggedIn) {
        clearTimeout(timeout);
        if (ctx.app.$modal.current === SIGN_UP_POPUP) {
          ctx.app.$modal.hide(SIGN_UP_POPUP);
        }
      }
    },
  );
};

export default SignUpPopupWithDelay;
